import { collection, doc, getDoc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { database } from './firebase';
import { COLLECTION } from '../constants/COLLECTION';

export const slugify = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'empreendimento';

const createToken = () => {
  if (window.crypto?.getRandomValues) {
    const values = new Uint32Array(2);
    window.crypto.getRandomValues(values);
    return Array.from(values)
      .map(value => value.toString(36))
      .join('')
      .slice(0, 8);
  }
  return Math.random()
    .toString(36)
    .slice(2, 10);
};

const getAvailableToken = async () => {
  let token = createToken();
  while (
    !(await getDocs(query(collection(database, COLLECTION.ENTERPRISES), where('publicToken', '==', token)))).empty
  ) {
    token = createToken();
  }
  return token;
};

export const getOrCreatePublicLink = async (id, name) => {
  const enterpriseRef = doc(database, COLLECTION.ENTERPRISES, id);
  const snapshot = await getDoc(enterpriseRef);
  const enterprise = snapshot.data();
  const token = enterprise?.publicToken || (await getAvailableToken());

  if (!enterprise?.publicToken) {
    await updateDoc(enterpriseRef, { publicToken: token });
  }

  return `${window.location.origin}/empreendimento/${slugify(name || enterprise?.name)}-${token}`;
};

export const getPublicEnterpriseQuery = token =>
  query(
    collection(database, COLLECTION.ENTERPRISES),
    where('publicToken', '==', token),
    where('status', '==', 'ACTIVE')
  );
